import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
var MutexLockStatus;

(function (MutexLockStatus) {
  MutexLockStatus[MutexLockStatus["LOCKED"] = 0] = "LOCKED";
  MutexLockStatus[MutexLockStatus["UNLOCKED"] = 1] = "UNLOCKED";
})(MutexLockStatus || (MutexLockStatus = {}));
/**
 * An async mutex lock.
 */


export var Mutex = /*#__PURE__*/function () {
  function Mutex() {
    _classCallCheck(this, Mutex);
  }

  _createClass(Mutex, null, [{
    key: "lock",
    value:
    /**
     * Lock for a specific key. If the lock has been acquired by another customer, then
     * will wait until getting the lock.
     *
     * @param key - lock key
     */
    function () {
      var _lock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve) {
                  if (_this.keys[key] === undefined || _this.keys[key] === MutexLockStatus.UNLOCKED) {
                    _this.keys[key] = MutexLockStatus.LOCKED;
                    resolve();
                  } else {
                    _this.onUnlockEvent(key, function () {
                      _this.keys[key] = MutexLockStatus.LOCKED;
                      resolve();
                    });
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function lock(_x) {
        return _lock.apply(this, arguments);
      }

      return lock;
    }()
    /**
     * Unlock a key.
     *
     * @param key -
     */

  }, {
    key: "unlock",
    value: function () {
      var _unlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  if (_this2.keys[key] === MutexLockStatus.LOCKED) {
                    _this2.emitUnlockEvent(key);
                  }

                  delete _this2.keys[key];
                  resolve();
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function unlock(_x2) {
        return _unlock.apply(this, arguments);
      }

      return unlock;
    }()
  }, {
    key: "onUnlockEvent",
    value: function onUnlockEvent(key, handler) {
      if (this.listeners[key] === undefined) {
        this.listeners[key] = [handler];
      } else {
        this.listeners[key].push(handler);
      }
    }
  }, {
    key: "emitUnlockEvent",
    value: function emitUnlockEvent(key) {
      var _this3 = this;

      if (this.listeners[key] !== undefined && this.listeners[key].length > 0) {
        var handler = this.listeners[key].shift();
        setImmediate(function () {
          handler.call(_this3);
        });
      }
    }
  }]);

  return Mutex;
}();
Mutex.keys = {};
Mutex.listeners = {};